export default __webpack_public_path__ + "static/media/hero-idea.7724a83f.webp";